import{a as e}from"./ninox-components-4KWCCUJ4.js";import{b as r}from"./ninox-components-DBZCHTU6.js";import l from"styled-components";var c=l(e)`
    display: inline-flex;
    align-items: center;
    justify-content: center;

    color: ${({color:o,theme:i})=>o||i.icon.secondary};
    vertical-align: middle;
    border-width: 0;

    &:hover:not(:disabled),
    &:focus {
        color: ${({theme:o,hoverColor:i})=>i||o.icon.primary};
    }

    &:focus-visible {
        filter: drop-shadow(${({hoverColor:o,theme:i})=>r.d1(o||i.icon.primary,.2)});
    }

    &:disabled {
        color: ${({theme:o,disabledColor:i})=>i||o.icon.disabled};
    }
`;export{c as a};
//# sourceMappingURL=ninox-components-WHJSBUYL.js.map